import {
  APPOINTMENT_STATUS_CODE,
  DEFAULT_APPOINTMENT_STATUS_CODE,
} from '@/constants/appointmentOptions';
import type { Appointment } from '@/api/appointments/appointmentsApi.types';

export function resolveAppointmentStatusCode(appointment: Appointment): string {
  if (appointment.status.length > 0) {
    return appointment.status;
  }
  return DEFAULT_APPOINTMENT_STATUS_CODE;
}

export function isAppointmentCompleted(appointment: Appointment): boolean {
  return appointment.status === APPOINTMENT_STATUS_CODE.completed;
}

export function isAppointmentCancelled(appointment: Appointment): boolean {
  return appointment.status === APPOINTMENT_STATUS_CODE.cancelled;
}

export function resolvePatientDisplayName(appointment: Appointment, fallbackText: string): string {
  if (appointment.patientName.length > 0) {
    return appointment.patientName;
  }
  return fallbackText;
}

export function resolveCaretakerDisplayName(
  appointment: Appointment,
  fallbackText: string
): string {
  if (appointment.clientName.length > 0) {
    return appointment.clientName;
  }
  return fallbackText;
}
